//#region IMPORTS
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { setOrdersWithSuborders } from "../../features/orders/ordersSlice";
import { useTranslation } from "react-i18next";
import ToggleButton from "../genericButtons/toggleButton/ToggleButton";
//#endregion

export default function OrdersTableControlePanelViewActions() {
  //#region SETUP
  // Translations
  const { t } = useTranslation();

  // Redux
  const dispatch = useAppDispatch();
  const { showOrdersWithSuborders, orders_loaded } = useAppSelector(
    (state) => state.orders
  );
  //#endregion

  //#region RENDER
  return (
    <div className="flex gap-4 items-center mr-4">
      <ToggleButton
        switchDisabled={!orders_loaded}
        startValue={showOrdersWithSuborders}
        label={
          showOrdersWithSuborders
            ? t("rituals.hideAllParcelInfo")
            : t("rituals.showAllParcelInfo")
        }
        toggleHandler={() => {
          dispatch(setOrdersWithSuborders(!showOrdersWithSuborders));
        }}
      />
    </div>
  );
  //#endregion
}
